// BWA stuff
import withProvider from '../../../gql/withProvider.js';

import PatientInfoFormContainer from './PatientInfoFormContainer';

export default withProvider(PatientInfoFormContainer);
